import { useMemo } from 'react';
export const useIconColor = (type) => {
    const iconColor = useMemo(() => {
        switch (type) {
            case 'success':
                return 'success-500';
            case 'error':
                return 'danger-500';
            case 'warning':
                return 'warning-500';
            case 'info':
                return 'primary-500';
        }
    }, [type]);
    return iconColor;
};
